import React from "react";

interface ClarificationBadgeProps<K extends Record<string, number>> {
  className?: string;
  colors: Record<K[keyof K], string>;
  labels: Record<K[keyof K], string>;
  value: K[keyof K];
}

export const ClarificationBadge = <K extends Record<string, number>>({
  colors,
  labels,
  value,
  className = "",
}: ClarificationBadgeProps<K>) => {

  if (!!!value) {
    return "-";
  }

  const colorClass = colors[value] || "bg-gray-100 text-gray-700";
  const label = labels[value] || 'Unknown';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${colorClass} ${className}`}
    >
      {label}
    </span>
  );
};
